import ReactDOM from 'react-dom';
import { Amplify } from 'aws-amplify';
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';
import { ApolloProvider } from '@apollo/client';
// eslint-disable-next-line import/no-extraneous-dependencies
import { LicenseInfo } from '@mui/x-license-pro';

// project imports
import App from 'App';
import { AWS_CONFIGURATION, BASE_PATH } from 'config';
import { store } from 'store';
import { ConfigProvider } from 'contexts/ConfigContext';
import { client } from 'graphql/config';
import { initializeGoogleAnalytics } from 'utils/analytics';
import 'assets/scss/style.scss';

LicenseInfo.setLicenseKey(process.env.REACT_APP_MUI_PRO_LICENSE ?? '');

initializeGoogleAnalytics();

Amplify.configure(AWS_CONFIGURATION);

ReactDOM.render(
    <Provider store={store}>
        <ConfigProvider>
            <ApolloProvider client={client}>
                <BrowserRouter basename={BASE_PATH}>
                    <App />
                </BrowserRouter>
            </ApolloProvider>
        </ConfigProvider>
    </Provider>,
    document.getElementById('root')
);
